




























import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';
import VLazyImage from 'v-lazy-image';

@Component({
  name: 'BannerWithSlot',
  components: {
    VLazyImage,
  },
})
export default class BannerWithSlot extends Vue {
  @Prop({type: Number, default: 480}) public readonly height?: number;
  @Prop({type: Object, default: () => {}}) public readonly imgSrc!: {};
  @Prop({type: Boolean, default: false}) public readonly fullscreenImg!: boolean;
  @Prop({type: Number, default: 0}) public readonly heightBlock!: number;
  @Prop({type: Number, default: 0}) public readonly topOffset!: number;
  @Prop({type: String, default: ''}) public readonly uniqueClass!: string;
  @Prop({type: Boolean, default: false}) public readonly relative!: boolean;
  // TODO: image size + image file with width
  private get srcImg(): string {
    return this.imgSrc?.[400];
  }

  private get srcImgPlaceholder(): string {
    return this.imgSrc?.[400];
  }

  private get srcSet(): string {
    return `${this.imgSrc?.[400]} 400w, ${this.imgSrc?.[800]} 800w,
      ${this.imgSrc?.[1300]} 1300w, ${this.imgSrc?.[1900]} 1900w, ${this.imgSrc?.[3600]} 3600w`;
  }

  public goTo(link: string): void {
    this.$router.push(link);
  }

  public triggerLoad() {
    (this as any).$refs.image.loaded = true;
  }
}
